import { useTranslation } from 'react-i18next';
import CasAccordion from '@customer/components/accordions/accordion/CasAccordion';
import AccordionHeader from '@customer/components/accordions/header/AccordionHeader';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { ControlledAccordion } from '@customer/components/accordions/useControlledAccordions';
import { AccordionStatus } from '@customer/components/accordions/types';
import AccordionBody from '@customer/components/accordions/body/AccordionBody';

interface AccordionNotificationTechBulletinProps {
  isNew: boolean;
  title: string;
  description: string;
  releaseDate: string;
  downloadUri: string;
  controlled?: ControlledAccordion;
}

export const AccordionNotificationTechBulletin = ({
  isNew,
  title,
  description,
  releaseDate,
  downloadUri,
  controlled,
}: AccordionNotificationTechBulletinProps) => {
  const { t } = useTranslation();
  const { showDateOnlyFromIso } = useLocaleFormatter();

  const status: AccordionStatus = isNew ? AccordionStatus.Informative : AccordionStatus.Neutral;
  const dateDisplay = showDateOnlyFromIso(releaseDate);
  const subtitle = `${dateDisplay}, ${t('TechnicalBulletin')}`;

  return (
    <CasAccordion
      status={status}
      icon="bell"
      controlled={controlled}
      header={<AccordionHeader title={title} subtitle={subtitle} />}
    >
      <AccordionBody
        title={subtitle}
        description={description}
        url={downloadUri}
        linkTitle={title}
      />
    </CasAccordion>
  );
};

export default AccordionNotificationTechBulletin;
